import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'app-modal-host',
  imports: [],
  templateUrl: './modal-host.component.html',
  styleUrl: './modal-host.component.scss',
})
export class ModalHostComponent {
  @ViewChild('modalContainer', { read: ViewContainerRef, static: true })
  containerRef!: ViewContainerRef;

  constructor(private modalService: ModalService) {}

  ngOnInit() {
    this.modalService.setContainerRef(this.containerRef);
  }
}
